import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { FaqProps } from './faq.props'

export const FaqType = ComponentTypeFactory.create<FaqProps>('Faq', {
  title: FieldTypeFactory.text(),
  isDev: FieldTypeFactory.boolean({ required: false }),
  contents: FieldTypeFactory.list({
    of: {
      question: FieldTypeFactory.text({ required: true }),
      answer: FieldTypeFactory.text({ required: true }),
      isDefaultOpened: FieldTypeFactory.boolean({
        defaultValue: false,
        required: true,
      }),
    },
  }),
})
